import { render } from "./IconUpload.vue?vue&type=template&id=6308a520"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6308a520"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6308a520', __exports__)) {
    api.reload('6308a520', __exports__)
  }
  
  module.hot.accept("./IconUpload.vue?vue&type=template&id=6308a520", () => {
    api.rerender('6308a520', render)
  })

}


export default __exports__